import { Component, inject } from '@angular/core';
import { BudgetOptionalAccessory } from 'src/app/models/budget-optional-accessory.model';
import { BudgetService } from 'src/app/services/budget.service';
import { ToastService } from 'src/app/services/toast.service';
import { NgClass } from '@angular/common';
import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';
import { EmptyStateComponent } from 'src/app/shared/ui/empty-state/empty-state.component';

@Component({
    selector: 'app-optional-accessory',
    templateUrl: './optional-accessory.component.html',
    styleUrls: ['./optional-accessory.component.scss'],
    imports: [NgClass, PageHeaderComponent, EmptyStateComponent]
})
export class OptionalAccessoryComponent {
  toastr = inject(ToastService);
  budgetSvc = inject(BudgetService);

  optionalAccessories: BudgetOptionalAccessory[] = [];

  ngOnInit() {
    this.getAllAccessories();
  }

  async getAllAccessories() {
    await new Promise(() => {
      this.budgetSvc.getAllAccesories().subscribe((data) => {
        this.optionalAccessories = data.sort((a, b) =>
          a.description.localeCompare(b.description)
        );
      });
    });
  }

  updateVariables(
    object: BudgetOptionalAccessory,
    editable: boolean,
    promotional: boolean
  ) {
    let objEdited = {
      id: object.id,
      description: object.description,
      type: object.type,
      isEditable: editable,
      isPromotionalAccessory: promotional,
    };
    this.budgetSvc.updateOptionaAccesory(objEdited).subscribe({
      next: (data) => {
        void this.handleUpdateVariablesSuccess();
      },
      error: (err) => {
        this.toastr.error(
          'Error al actualizar',
          'No se ha podido actualizar el accesorio.'
        );
      },
    });
  }

  private async handleUpdateVariablesSuccess(): Promise<void> {
    this.toastr.success(
      'Actualizado',
      'El accesorio se actualizó correctamente.'
    );
    await this.getAllAccessories();
  }
}
